export const INIT_DIRECTIONS = [
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.INTERNAL',
    value: 'internal' as 'internal',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.CIS',
    value: 'CIS' as 'CIS',
  },
  {
    label: 'BATCH_MAILING.BATCHES_TAB.METADATA.INTERNATIONAL',
    value: 'international' as 'international',
  },
];

export let DIRECTIONS = Array.from(INIT_DIRECTIONS);

export function setDirections(newDirections: typeof DIRECTIONS) {
  DIRECTIONS = newDirections;
}

export function resetDirections() {
  DIRECTIONS = Array.from(INIT_DIRECTIONS);
}

export type DirectionType = (typeof DIRECTIONS)[number]['value'];
export const DIRECTIONS_MAP = new Map<string, string>(
  DIRECTIONS.map<[string, string]>((item) => [item.value, item.label])
);
